module.exports = __webpack_public_path__ + "static/media/business-forex-chart-sc.eb8dd228.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/business-forex-chart-sc.png
// module id = 501
// module chunks = 0